import { useEffect } from 'react';
import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutStory from './components/AboutStory';
import AboutTestimonials from './components/AboutTestimonials';
import AboutCTA from './components/AboutCTA';

const baseUrl = 'http://kiyvx.cn/';

const aboutJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '178漫画网',
    url: baseUrl,
    description: '178漫画网是国内领先的高清漫画在线阅读平台，提供漫画全集免费阅读下拉式服务。',
    foundingDate: '2018',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-178-0000',
      email: 'hello@kiyvx.cn',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      streetAddress: '漫画产业园区A座',
    },
    sameAs: [
      'http://kiyvx.cn/',
      'http://kiyvx.cn/178manhua',
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: baseUrl },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: `${baseUrl}/about`,
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于178漫画网 - 品牌故事与商务合作',
    description: '了解178漫画网的品牌故事、平台数据、编辑寄语和商务合作联系方式。高清漫画全集免费阅读下拉式平台。',
    url: `${baseUrl}/about`,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '178漫画网是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，178漫画网提供高清漫画全集免费阅读下拉式服务，无需付费即可享受超清画质和流畅阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '178漫画网有多少漫画资源？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '178漫画网目前收录超过5000部正版授权漫画，涵盖治愈、热血、恋爱、悬疑等多种类型。',
        },
      },
      {
        '@type': 'Question',
        name: '如何与178漫画网进行商务合作？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '欢迎通过邮箱 hello@kiyvx.cn 或电话 400-178-0000 联系我们，进行版权合作、广告投放、作者入驻等商务洽谈。',
        },
      },
      {
        '@type': 'Question',
        name: '178漫画网的阅读体验如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '178漫画网采用超清画质和下拉式阅读模式，翻页流畅自然，为读者提供极致的视觉盛宴和沉浸式阅读体验。',
        },
      },
    ],
  },
];

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEOHead
        title="关于178漫画网 - 品牌故事、平台数据与商务合作"
        description="了解178漫画网的品牌故事与发展历程。平台收录5000+部漫画，1000万+注册用户，98%好评率。提供版权合作、广告投放、作者入驻等商务合作渠道。"
        keywords="178漫画网,关于我们,品牌故事,商务合作,漫画平台,高清漫画,免费阅读,下拉式"
        canonicalUrl={`${baseUrl}/about`}
        ogImage="https://readdy.ai/api/search-image?query=Warm%20creative%20studio%20workspace%20with%20manga%20art%20supplies%2C%20soft%20lighting%2C%20professional%20atmosphere%2C%20about%20us%20page%20og%20image&width=1200&height=630&seq=og-about-01&orientation=landscape"
        jsonLd={aboutJsonLd}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <AboutStory />
          <AboutTestimonials />
          <AboutCTA />
        </main>
        <Footer />
      </div>
    </>
  );
}